import { Col, Container, Row } from "react-bootstrap";
import JSONPretty from "../../jsonPrettyOverride/JSONPretty";
import classes from "./IntegrationOverview.module.scss"
import { tx } from "../../../lib/ddd/ddd";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DataObjectIcon from '@mui/icons-material/DataObject';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import DataArrayIcon from '@mui/icons-material/DataArray';
import NumbersIcon from '@mui/icons-material/Numbers';
import SettingsIcon from '@mui/icons-material/Settings';
import ArticleIcon from '@mui/icons-material/Article';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ApiIcon from '@mui/icons-material/Api';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import Button from "../../UI/Button";
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import ForwardIcon from '@mui/icons-material/Forward';
import { NavLink } from "react-router-dom";


const WhatsNext = () => {
    const json1 = {"Object" : {}, Complexity:"Normal"}
    const json2 = {"Id" : "" , "Steps":[], Complexity:"Normal"}
    const json3 = {"Id" : "", "ReturnDoc":[], Complexity:"Normal"}
    const json4 = {"Object" : {},"Steps":[], "ReturnDoc":[],Complexity:"Normal"}

    return (
        <>
            <Row style={{marginTop:"2rem", marginBottom:"2rem"}}>
                <Col><NavLink to="/integration-wizard-step"><Button><LooksTwoIcon style={{marginRight:"1rem"}}/>Go to steps<ForwardIcon style={{marginLeft:"1rem"}}/></Button></NavLink></Col>
                <Col><NavLink to="/integration-wizard-return"><Button><Looks3Icon style={{marginRight:"1rem"}}/>How to get invoice documents<ForwardIcon style={{marginLeft:"1rem"}}/></Button></NavLink></Col>
                <Col><NavLink to="/integration-wizard-full"><Button><NumbersIcon style={{marginRight:"1rem"}}/>Go to sending combined<ForwardIcon style={{marginLeft:"1rem"}}/></Button></NavLink></Col>
            </Row>
            <Row className={`flex-nowrap ${classes["jsons-row"]}`}>
                <Col>
                    <Row className="h-100" >
                        <Col className="h-100" >
                            <div className={`${classes["desc-wrapper"]} flex-column d-flex`}>
                                <h5 className={classes["wiz-title"]}>2. Steps</h5>
                                <ul className={`${classes["pricing-table-ul"]} ${classes["profile"]}`} style={{textAlign:"left"}}>
                                    <li><SettingsIcon className={classes["fa"]}/>Here, we will select all the steps that will be performed on our invoice 
                                                                                    (for example, the step code for sending to the Tax authorities is 70)</li>
                                    <li><DataArrayIcon className={classes["fa"]}/>This will be a simple array of integers that we will put under the "Steps" property</li>
                                    <li><NumbersIcon className={classes["fa"]}/>Each step has its own code. We will learn which ones are available and include them on our test invoice</li>
                                </ul>
                                <div className="mt-auto w-100">
                                {/* <img src={stepsPic} width="100%" alt="stepsPic"/> */}
                                </div>
                            </div>
                        </Col>
                        <Col className="col-1 align-self-center"></Col>
                    </Row>
                </Col>
                <Col>
                    <Row className="h-100" >
                        <Col className="h-100" >
                            <div className={`${classes["desc-wrapper"]} flex-column d-flex`}>
                                <h5 className={classes["wiz-title"]}>3. Returned documents</h5>
                                <ul className={`${classes["pricing-table-ul"]} ${classes["profile"]}`} style={{textAlign:"left"}}>
                                    <li><SettingsIcon className={classes["fa"]}/>We will decide which documents we require back</li>
                                    <li><ArticleIcon className={classes["fa"]}/>The API response upon successful execution of our invoice and steps will return the links to these documents</li>
                                    <li><DataArrayIcon className={classes["fa"]}/>Just like with steps, each document has its own code that will be passed in a simple array. (for example, the code for PDF is simply "PDF")</li>
                                </ul>
                                <div className="mt-auto w-100"></div>
                            </div>
                        </Col>
                        <Col className="col-1 align-self-center"></Col>
                    </Row>
                </Col>
                <Col>
                    <Row className="h-100" >
                        <Col className="h-100" >
                            <div className={`${classes["desc-wrapper"]} flex-column d-flex`}>
                                <h5 className={classes["wiz-title"]}><NumbersIcon/> Full</h5>
                                <ul className={`${classes["pricing-table-ul"]} ${classes["profile"]}`} style={{textAlign:"left"}} >
                                    <li><CloudUploadIcon className={classes["fa"]}/>The final step is to execute our invoice with all the parameters combined</li>
                                    <li><ApiIcon className={classes["fa"]}/>For that, we are going to send your invoice to {tx("DDDI_Save")} API with all the parameters (Object, Steps, ReturnDoc)</li>
                                    <li><DoneAllIcon className={classes["fa"]}/>If all goes well, your invoice should be processed according to the information and steps your selected</li>
                                </ul>
                                <div className="mt-auto w-100">
                                {/* <img src={overviewPic} width="100%" alt="frac"/> */}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className={`flex-nowrap ${classes["jsons-row"]}`}>
                <Col>
                    <Row className="h-100 flex-nowrap" >
                        <Col className="h-100" >
                            <div className={classes["form-wrapper"]} style={{textAlign : "left", borderRadius:"10px"}}>
                                <JSONPretty data={json2} fieldName={"Steps"}/>
                            </div>
                        </Col>
                        <Col className="col-1 align-self-center"></Col>
                    </Row>
                </Col>
                <Col>
                    <Row className="h-100 flex-nowrap" >
                        <Col className="h-100" >
                            <div className={classes["form-wrapper"]} style={{textAlign : "left", borderRadius:"10px"}}>
                                <JSONPretty data={json3} fieldName={"ReturnDoc"}/>
                            </div>
                        </Col>
                        <Col className="col-1 align-self-center"></Col>
                    </Row>
                </Col>
                <Col>
                    <Row className="h-100 flex-nowrap" >
                        <Col className="h-100" >
                            <div className={classes["form-wrapper"]} style={{textAlign : "left", borderRadius:"10px"}}>
                                <JSONPretty data={json4}/>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            
            </>
    )
}

export default WhatsNext;